<template>
  <a-card :bordered="false">
    <!-- 搜索区域 -->
    <div class="table-page-search-wrapper" style="margin-bottom: 20px;">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :span="6">
            <a-form-item label="提交时间：" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-range-picker
                v-model="dateRange"
                valueFormat="YYYY-MM-DD"
                style="width: 100%;"
              />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="产品：" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-select v-model="productType" placeholder="请选择">
                <a-select-option :value="0">全部</a-select-option>
                <a-select-option :value="1">主产品</a-select-option>
                <a-select-option :value="2">子产品</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="借款类型：" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-select v-model="loanType" placeholder="请选择">
                <a-select-option :value="0">全部</a-select-option>
                <a-select-option :value="1">首贷</a-select-option>
                <a-select-option :value="2">复贷</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleSearchList" icon="search">查询</a-button>
              <a-button @click="handleResetSearch" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 表格区域 -->
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="appSsid"
      :columns="columns"
      :dataSource="list"
      :pagination="false"
      :loading="listLoading"
    >
    </a-table>
  </a-card>
</template>

<script>
import { getAppRiskReport } from '@/api/riskReport'

export default {
  name: 'appRiskReport',
  data() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const today = `${year}-${month}-${day}`;
    return {
      dateRange: [today, today],
      productType: 0,
      loanType: 0,
      list: [],
      listLoading: false,
      columns: [
        { title: 'APP_SSID', dataIndex: 'appSsid', align: 'center' },
        { title: '申请笔数', dataIndex: 'applyCount', align: 'center' },
        
        { title: 'A风控通过', dataIndex: 'passCountA', align: 'center' },
        { title: 'A放款笔数', dataIndex: 'loanCountA', align: 'center' },
        { title: 'A坏账笔数', dataIndex: 'badDebtCountA', align: 'center' },
        { title: 'A坏账率', dataIndex: 'badDebtRateA', align: 'center' },

        { title: 'B风控通过', dataIndex: 'passCountB', align: 'center' },
        { title: 'B放款笔数', dataIndex: 'loanCountB', align: 'center' },
        { title: 'B坏账笔数', dataIndex: 'badDebtCountB', align: 'center' },
        { title: 'B坏账率', dataIndex: 'badDebtRateB', align: 'center' },

        { title: 'C风控通过', dataIndex: 'passCountC', align: 'center' },
        { title: 'C放款笔数', dataIndex: 'loanCountC', align: 'center' },
        { title: 'C坏账笔数', dataIndex: 'badDebtCountC', align: 'center' },
        { title: 'C坏账率', dataIndex: 'badDebtRateC', align: 'center' },

        { title: '总放款笔数', dataIndex: 'loanCount', align: 'center' },
        { title: '总坏账笔数', dataIndex: 'badDebtCount', align: 'center' },
        { title: '总坏账率', dataIndex: 'badDebtRate', align: 'center' }
      ]
    }
  },
  created() {
    this.handleSearchList()
  },
  methods: {
    handleSearchList() {
      this.listLoading = true
      const params = {
        productType: this.productType,
        loanType: this.loanType
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0]
        params.endDate = this.dateRange[1]
      }
      getAppRiskReport(params).then(res => {
        if (res.code === 1000 || res.code === 200) {
          this.list = res.data || []
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    handleResetSearch() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      this.dateRange = [`${year}-${month}-${day}`, `${year}-${month}-${day}`]
      this.productType = 0
      this.loanType = 0
      this.handleSearchList()
    }
  }
}
</script>
